import { render, staticRenderFns } from "./DetailBankStatement.vue?vue&type=template&id=0136af42"
import script from "./DetailBankStatement.vue?vue&type=script&lang=js"
export * from "./DetailBankStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports